import { Accordion } from "@softura/customcomponent";
import "./Accordion.scss";

interface IProps {
  Items?: any;
  className?: any;
  uuid?: any;
  allowZeroExpanded?: any;
  allowMultipleExpanded?: any;
  preExpanded?: any;
  onChange?: any;
  accordionItemClassName?:any
}

const AccordionComponent = ({
  Items = [],
  className = "",
  uuid,
  preExpanded,
  onChange,
  accordionItemClassName,
  allowMultipleExpanded = 'true'
}: IProps) => (
  <Accordion
    items={Items}
    className={`accodion-container ${className}`}
    uuid={uuid}
    allowMultipleExpanded={allowMultipleExpanded}
    allowZeroExpanded="true"
    preExpanded={preExpanded}
    onChange={onChange}
    accordionItemClassName={accordionItemClassName}
   data-attribute="index_Default_Accordion" />
);

export default AccordionComponent;
